import React, { useState, useMemo, useCallback } from "react";
import { Box, Typography, Button, Avatar } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import profileImage from "../../assets/images/profile.png";
import { logout } from "../../services/authService";
import { toast } from "react-toastify";

export default function CandidateHeader() {
  const navigate = useNavigate();
  const { projectDetails } = useSelector(
    (state) => state.examReducer
  );


  // ✅ Direct read – same as Thank You page
  const candidateData = useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem("candidate_details")) || {};
    } catch {
      return {};
    }
  }, []);

  const candidateName = candidateData?.name ?? "—";
  const rollNo = candidateData?.rollNo ?? candidateData?.username ?? "—";
  const photoUrl = candidateData?.photo ?? profileImage;

  const handleLogout = useCallback(async () => {
    const response = await Promise.resolve(logout());

    if (response?.status !== 200) {
      toast.error("Logout failed. Please try again.");
    }
  }, []);

  return ( 
    <Box className="g-header">
      <Box className="g-flex" style={{ alignItems: "center", gap: "12px" }}>
        <Avatar src={photoUrl} sx={{ width: 40, height: 40 }} />
        <Box className="g-flex-column">
          <Typography className="g-text-bold">
            {candidateName}
          </Typography>
          <Typography className="g-text-sm">
            ({rollNo})
          </Typography>
        </Box>
      </Box>
      <Button
        variant="outlined"
        color="error"
        className="g-btn g-btn-icon"
        startIcon={<LogoutIcon />}
        onClick={handleLogout}
      >
        Logout
      </Button>
    </Box>
  );
}
